<template>
  <div style="
      background: url('https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704181755475.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    ">
    <el-row>
      <el-col :span="6" style="">
        <div>
          <div class="" style="
              width: 100%;
              height: 263px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728379502499.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div style="
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 75px;
              ">
              <div class="" style="
                  width: 40%;
                  height: 183px;
                  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728377857650.png);
                  background-repeat: no-repeat;
                  background-size: contain;
                ">
                <div class="" style="
                    margin-top: -13px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 38px;
                    color: #0073ff;
                    text-shadow: 1px 2px 2px #ffffff;
                    font-family: YouSheBiaoTiHei;
                    font-weight: bold;
                  ">
                  {{ parkList.length }}
                </div>
              </div>
              <div style="width: 60%">
                <div id="leftMainOne" style="width: 100%; height: 183px"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="" style="
              margin-top: 20px;
              width: 100%;
              height: 263px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728379335162.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div style="
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 75px;
              ">
              <div class="" style="
                  width: 40%;
                  height: 183px;
                  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728632167996.png);
                  background-repeat: no-repeat;
                  background-size: contain;
                ">
                <div class="" style="
                    margin-top: -13px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 38px;
                    color: #00feff;
                    text-shadow: 1px 2px 2px #ffffff;
                    font-family: YouSheBiaoTiHei;
                    font-weight: bold;
                  ">
                  {{ deviceList.length }}
                </div>
              </div>
              <div style="width: 60%">
                <div id="leftMainTwo" style="width: 100%; height: 183px"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="" style="
              display: flex;
              align-items: flex-end;
              margin-top: 20px;
              width: 100%;
              height: 390px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728463979492.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div class="hide-scrollbar" style="width: 100%; height: 335px; overflow: scroll">
              <div class="" style="
                  background: rgba(176, 218, 239, 0.15);
                  display: flex;
                  align-items: center;
                  padding: 10px 0;
                  text-align: center;
                  color: #a6cadc;
                ">
                <div style="flex: 2">设备名称</div>
                <div style="flex: 1">设备状态</div>
                <div style="flex: 2">所在园区</div>
              </div>
              <div @click="changeDevice(item)" v-for="item in deviceList" :key="item.hothouseDeviceId" style="
                  margin-top: 10px;
                  display: flex;
                  align-items: center;
                  padding: 10px 0;
                  text-align: center;
                " :style="changeDeviceItem.hothouseDeviceId == item.hothouseDeviceId
                  ? 'background: rgba(24, 254, 240, 0.2);color: #18FEF0;'
                  : 'background: rgba(176, 218, 239, 0.05);color: #A6CADC;'
                  ">
                <el-tooltip class="item" effect="dark" :content="item.hothouseDeviceName" placement="top">
                  <div style="
                      flex: 2;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">
                    {{ item.hothouseDeviceName }}
                  </div>
                </el-tooltip>
                <div style="flex: 1">
                  {{ item.hothouseDeviceState == 2 ? "在线" : "离线" }}
                </div>
                <el-tooltip class="item" effect="dark" :content="item.massifName" placement="top">
                  <div style="
                      flex: 2;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">
                    {{ item.massifName }}
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="display: flex">
          <div class="" style="
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 535px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728637217948.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div class="" style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 40px;
                width: 100%;
                height: 80%;
                background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728611490494.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
              ">
              <div id="container" style="width: 98%; height: 98%"></div>
            </div>
          </div>
          <div class="" style="
              flex: 1;
              width: 100%;
              height: 535px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728636170107.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div style="
                margin-top: 70px;
                width: 100%;
                margin-left: 20px;
                margin-right: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #ffffff;
                text-align: center;
              ">
              <div style="
                  font-style: italic;
                  width: 50%;
                  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
                ">
                <div style="font-size: 30px; font-weight: bold">兰州市安宁区</div>
                <div style="font-size: 16px; font-weight: bold; margin-top: 8px">
                  当前地区
                </div>
              </div>
              <div style="width: 50%; font-size: 26px; font-weight: bold">
                <div style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  ">
                  {{ weatherData.temp }}℃
                </div>
              </div>
            </div>
            <div style="margin-left: 20px; margin-right: 20px; margin-top: 20px">
              <div class="" style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  text-align: center;
                ">
                <div style="width: 30%; display: flex; align-items: center">
                  <div class="">
                    <div style="font-size: 14px; font-weight: bold; color: #e4eff5">
                      湿度
                    </div>
                    <div class="" style="
                        margin-top: 8px;
                        font-weight: bold;
                        background: linear-gradient(
                          180deg,
                          #76ffe8 2%,
                          #48d895 100%
                        );
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: #fff;
                        background-clip: text;
                        text-fill-color: #fff;
                      ">
                      {{ weatherData.humidity }}%RH
                    </div>
                  </div>
                  <div style="margin-left: 8px">
                    <div style="font-size: 14px; font-weight: bold; color: #e4eff5">
                      温度
                    </div>
                    <div class="" style="
                        margin-top: 8px;
                        font-weight: bold;
                        background: linear-gradient(
                          180deg,
                          #ffecb5 6%,
                          #ffc317 100%
                        );
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: #fff;
                        background-clip: text;
                        text-fill-color: #fff;
                      ">
                      {{ weatherData.temp }}℃
                    </div>
                  </div>
                </div>
                <div class="" style="
                    width: 70%;
                    padding: 20px 0;
                    display: flex;
                    display: flex;
                    align-items: center;
                    border-radius: 10px;
                    background: #071b43;
                  ">
                  <div style="flex: 1">
                    <div>{{ weatherData.windScale }}级</div>
                    <div style="margin-top: 8px">{{ weatherData.windDir }}</div>
                  </div>
                  <div style="
                      border-left: 1px solid #d8d8d8;
                      width: 1px;
                      height: 22px;
                    "></div>
                  <div style="flex: 1">
                    <div>{{ weatherData.humidity }}%RH</div>
                    <div style="margin-top: 8px">相对湿度</div>
                  </div>
                  <div style="
                      border-right: 1px solid #d8d8d8;
                      width: 1px;
                      height: 22px;
                    "></div>
                  <div style="flex: 1">
                    <div>{{ weatherData.feelsLike }}℃</div>
                    <div style="margin-top: 8px">体感温度</div>
                  </div>
                </div>
              </div>
              <div class="" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 10px;
                  width: 100%;
                  height: 258px;
                  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728637365999.png);
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                ">
                <hls-player v-if="liveList.length > 0" :hls-url="liveList[0].data.url" />

                <div v-else style="
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                  ">
                  暂无直播
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 390px;
            background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728614922440.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
          ">
          <div style="width: 396px; padding: 30px">
            <div style="">
              <img style="width: 366px; height: 123px"
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728615076483.png" alt="" />
            </div>
            <div style="
                margin-top: 20px;
                font-style: italic;
                font-size: 20px;
                font-weight: bold;
                display: flex;
                justify-content: space-between;
                align-items: center;
              ">
              <div style="color: #ffffff">
                {{ changeDeviceItem.hothouseDeviceName }}
              </div>
              <div style="display: flex; align-items: center">
                <div style="" :style="changeDeviceItem.hothouseDeviceState == 2
                  ? 'color: #18FEF0;'
                  : 'color: #8A9FC2;'
                  ">
                  {{
                    changeDeviceItem.hothouseDeviceState == 2 ? "在线" : "离线"
                  }}
                </div>
                <div style="
                    margin-left: 8px;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                  " :style="changeDeviceItem.hothouseDeviceState == 2
                    ? 'background: #18FEF0;'
                    : 'background: #8A9FC2;'
                    "></div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <div style="
                  font-style: italic;
                  font-size: 20px;
                  font-weight: bold;
                  color: #ffffff;
                ">
                所在园区：
              </div>
              <div style="margin-top: 8px; font-size: 16px; color: #ffffff">
                {{ changeDeviceItem.massifName }}
              </div>
            </div>
          </div>
          <div style="
              margin-top: 40px;
              width: calc(100% - 396px);
              display: grid;
              grid-template-columns: auto auto auto auto;
              gap: 10px;
              text-align: center;
            ">
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img style="width: 48px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728617668163.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[0].type ||
                    changeDeviceItemDataStatus[0].type1
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 17px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>卷帘机1</div>
                  <div>
                    {{
                      changeDeviceItemDataStatus[0].type ||
                        changeDeviceItemDataStatus[0].type1
                        ? "打开"
                        : "关闭"
                    }}
                    {{ changeDeviceItemDataStatus[0].num }}
                  </div>
                </div>
              </div>
            </div>
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img style="width: 48px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728617668163.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[1].type ||
                    changeDeviceItemDataStatus[1].type1
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 17px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>卷帘机2</div>
                  <div>
                    {{
                      changeDeviceItemDataStatus[1].type ||
                        changeDeviceItemDataStatus[1].type1
                        ? "打开"
                        : "关闭"
                    }}
                    {{ changeDeviceItemDataStatus[1].num }}
                  </div>
                </div>
              </div>
            </div>
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img style="width: 40px; height: 40px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618138145.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[2].type ||
                    changeDeviceItemDataStatus[2].type1
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>上风口</div>
                  <div>
                    {{
                      changeDeviceItemDataStatus[2].type ||
                        changeDeviceItemDataStatus[2].type1
                        ? "打开"
                        : "关闭"
                    }}
                    {{ changeDeviceItemDataStatus[2].num }}
                  </div>
                </div>
              </div>
            </div>
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img style="width: 40px; height: 40px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618216851.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[3].type ||
                    changeDeviceItemDataStatus[3].type1
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>下风口</div>
                  <div>
                    {{
                      changeDeviceItemDataStatus[3].type ||
                        changeDeviceItemDataStatus[3].type1
                        ? "打开"
                        : "关闭"
                    }}
                    {{ changeDeviceItemDataStatus[3].num }}
                  </div>
                </div>
              </div>
            </div>
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img v-if="changeDeviceItemDataStatus[4].type" style="width: 33px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618280472.png" alt="" />
                  <img v-else style="width: 33px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618283619.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[4].type
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>继电器1</div>
                  <div>
                    {{ changeDeviceItemDataStatus[4].type ? "打开" : "关闭" }}
                  </div>
                </div>
              </div>
            </div>
            <div style="
                background-color: rgba(57, 126, 214, 0.2);
                border-radius: 10px;
              ">
              <div style="padding: 16px 6px">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <img v-if="changeDeviceItemDataStatus[5].type" style="width: 33px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618280472.png" alt="" />
                  <img v-else style="width: 33px; height: 30px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728618283619.png" alt="" />
                  <div style="width: 8px; height: 8px; border-radius: 50%" :style="changeDeviceItemDataStatus[5].type
                    ? 'background: #00FFEF;'
                    : 'background: #8A9FC2;'
                    "></div>
                </div>
                <div style="
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>继电器2</div>
                  <div>
                    {{ changeDeviceItemDataStatus[5].type ? "打开" : "关闭" }}
                  </div>
                </div>
              </div>
            </div>
            <div style=""></div>
            <div style=""></div>
            <div style="background-color: #ffcd4d; border-radius: 10px">
              <div style="
                  padding: 16px 6px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <div style="margin-right: 10px">
                  <img style="width: 20px; height: 37px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728622019764.png" alt="" />
                </div>
                <div>
                  <div style="display: flex; align-items: center">
                    <div>
                      <img style="width: 11px; height: 10px"
                        src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728621888140.png" alt="" />
                    </div>
                    <div>空气温度</div>
                  </div>
                  <div style="margin-top: 8px">
                    {{ changeDeviceItemData.C }}℃
                  </div>
                </div>
              </div>
            </div>
            <div style="background-color: #52aeff; border-radius: 10px">
              <div style="
                  padding: 16px 6px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <div style="margin-right: 10px">
                  <img style="width: 26px; height: 36px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728622595134.png" alt="" />
                </div>
                <div>
                  <div style="display: flex; align-items: center">
                    <div>
                      <img style="width: 11px; height: 10px"
                        src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728621888140.png" alt="" />
                    </div>
                    <div>空气湿度</div>
                  </div>
                  <div style="margin-top: 8px">
                    {{ changeDeviceItemData.RH }}%RH
                  </div>
                </div>
              </div>
            </div>
            <div style="background-color: #ff8989; border-radius: 10px">
              <div style="
                  padding: 16px 6px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <div style="margin-right: 10px">
                  <img style="width: 36px; height: 36px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728622655694.png" alt="" />
                </div>
                <div>
                  <div style="display: flex; align-items: center">
                    <div>
                      <img style="width: 11px; height: 10px"
                        src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728621888140.png" alt="" />
                    </div>
                    <div>光照度</div>
                  </div>
                  <div style="margin-top: 8px">
                    {{ changeDeviceItemData.LUX }}Lux
                  </div>
                </div>
              </div>
            </div>
            <div style="background-color: #5fc97b; border-radius: 10px">
              <div style="
                  padding: 16px 6px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <div style="margin-right: 10px">
                  <img style="width: 41px; height: 29px"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728622665620.png" alt="" />
                </div>
                <div>
                  <div style="display: flex; align-items: center">
                    <div>
                      <img style="width: 11px; height: 10px"
                        src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728621888140.png" alt="" />
                    </div>
                    <div>二氧化碳</div>
                  </div>
                  <div style="margin-top: 8px">
                    {{ changeDeviceItemData.PPM }}PPM
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <div class="" style="
              width: 100%;
              height: 230px;
              /* background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728636090767.png); */
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div class="title1-img">
              <div class="titles">{{ powerInfo ? powerInfo.powerWarmRegion1Name + '数据分析' : '温湿度数据分析' }}</div>
            </div>
            <div style="
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 5px;
              ">
              <div id="rightMainOne" style="width: 100%; height: 185px"></div>
            </div>
          </div>
        </div>
        <div>
          <div class="" style="
              width: 100%;
              height: 230px;
              /* background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728636127857.png); */
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div class="title1-img">
              <div class="titles">{{ powerInfo ? powerInfo.powerWarmRegion2Name + '统计图' : '二氧化碳统计图' }}</div>
            </div>
            <div style="
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 5px;
              ">
              <div id="rightMainTwo" style="width: 100%; height: 185px"></div>
            </div>
          </div>
        </div>
        <div>
          <div class="" style="
              width: 100%;
              height: 230px;
              /* background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728636165821.png); */
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div class="title1-img">
              <div class="titles">{{ powerInfo ? powerInfo.powerWarmRegion3Name + '统计图' : '光照统计图' }}</div>
            </div>
            <div style="
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 5px;
              ">
              <div id="rightMainThree" style="width: 100%; height: 185px"></div>
            </div>
          </div>
        </div>
        <div>
          <div class="" style="
              width: 100%;
              height: 230px;
              background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728636145797.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
            ">
            <div style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 75px;
                text-align: center;
              ">
              <div style="margin-top: 50px">暂无预警信息</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/javascript"
  src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"></script>
<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";

import HlsPlayer from "@/components/HlsPlayer/HlsPlayer.vue";
import * as echarts from "echarts";
export default {
  components: {
    HlsPlayer,
  },
  data() {
    return {
      liveList: [],
      weatherData: {},
      nowTime: "",
      leftOneECharts: {},
      leftOneOption: {
        color: ["#00FF9D", "#63CAFF"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "left",
          data: [
            {
              name: "基地占地面积(m³)",
              textStyle: {
                color: "#00FF9D",
              },
            },
            {
              name: "设备总数",
              textStyle: {
                color: "#63CAFF",
              },
            },
          ],
        },
        grid: {
          width: 100,
          height: 100,
        },
        series: [
          {
            // name: '基地信息',
            type: "pie",
            radius: ["40%", "70%"],
            roseType: "radius",
            itemStyle: {
              borderRadius: 5,
            },
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            data: [
              {
                value: 1000,
                name: "基地占地面积(m³)",
              },
              {
                value: 44,
                name: "设备总数",
              },
            ],
          },
        ],
      },
      letfTwoECharts: {},
      leftTwoOption: {
        color: ["#00FF9D", "#63CAFF"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "left",
          data: [
            {
              name: "在线设备",
              textStyle: {
                color: "#00FF9D",
              },
            },
            {
              name: "离线设备",
              textStyle: {
                color: "#63CAFF",
              },
            },
          ],
        },
        series: [
          {
            // name: 'Access From',
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 15,
                name: "在线设备",
              },
              {
                value: 29,
                name: "离线设备",
              },
            ],
          },
        ],
      },
      map: {},
      mapLat: "103.71,36.53",
      mapRadio: "卫星",
      mapRadioType: "normal",

      /* 温/湿度echarts */
      rightOneChart: {},
      rightOneOption: {
        color: ["#00FFE7", "#F9F056"],
        tooltip: {
          trigger: "axis",
        },
        // title: {
        //   text: "单位：℃/%RH",
        //   textStyle: {
        //     color: "#fff",
        //     fontWeight: "none",
        //   },
        // },
        legend: {
          // padding: [1, 1, 1, 1],
          data: [
            {
              name: "空气温度",
              textStyle: {
                color: "#ffffff",
              },
            },
            {
              name: "空气湿度",
              textStyle: {
                color: "#ffffff",
              },
            },
          ],
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
            "00:00",
          ],
        },
        yAxis: [
          {
            type: "value",
            name: "°C",
            axisLabel: {
              textStyle: {
                // color: "#030c39",
              },
            },
          },
          {
            type: "value",
            name: "%RH",
            axisLabel: {
              textStyle: {
                // color: "#030c39",
              },
            },
          },
          // type: "value",
          // splitLine: {
          //   lineStyle: {
          //     // 使用深浅的间隔色
          //     color: ["#030c39"],
          //   },
          // },
        ],
        series: [
          {
            name: "空气温度",
            type: "line",
            stack: "Total",
            data: [
              150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190, 330,
              410, 150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190,
              330, 410,
            ],
          },
          {
            name: "空气湿度",
            type: "line",
            stack: "Total",
            yAxisIndex: 1,
            data: [
              320, 332, 301, 334, 390, 330, 320, 320, 332, 301, 334, 390, 330,
              320, 320, 332, 301, 334, 390, 330, 320, 320, 332, 301, 334, 390,
              330, 320,
            ],
          },
        ],
      },
      /* 二氧化碳echarts */
      rightTwoChart: {},
      rightTwoOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        // title: {
        // 	text: "单位：PPM",
        // 	textStyle: {
        // 		color: "#fff",
        // 		fontWeight: "none",
        // 	},
        // },
        grid: {
          top: "18%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
            "00:00",
          ],
        },
        yAxis: {
          type: "value",
          name: "单位：PPM",
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ["#030c39"],
            },
          },
        },
        series: [
          {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#00FFAB",
                },
                {
                  offset: 1,
                  color: "#83bff6",
                },
              ]),
            },
            data: [
              150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190, 330,
              410, 150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190,
              330, 410,
            ],
            type: "bar",
          },
        ],
      },
      /* 光照度echarts */
      rightThreeChart: {},
      rightThreeOption: {
        tooltip: {
          trigger: "axis",
        },
        // title: {
        // 	text: "单位：Lux",
        // 	textStyle: {
        // 		color: "#fff",
        // 		fontWeight: "none",
        // 	},
        // },
        grid: {
          top: "18%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
            "00:00",
          ],
        },
        yAxis: {
          type: "value",
          name: "单位：Lux",
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ["#030c39"],
            },
          },
        },
        series: [
          {
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            data: [
              150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190, 330,
              410, 150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 154, 190,
              330, 410,
            ],
            type: "line",
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
          },
        ],
      },
      deviceList: [],
      changeDeviceItem: {}, //切换设备（当前的）
      changeDeviceItemData: {
        //切换设备实时数据（当前的）
        C: "-",
        RH: "-",
        LUX: "-",
        PPM: "-",
      },
      changeDeviceItemDataStatus: [
        {
          //切换设备实时数据（当前的）
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
        },
        {
          num: "-",
          type: false,
        },
      ],
      parkList: [],
      userInfo: {},
      powerInfo:{}
    };
  },

  mounted() {
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);

    let powerInfo = localStorage.getItem("power_info");
    this.powerInfo = JSON.parse(powerInfo); 
    console.log("mounted===this.powerInfo", this.powerInfo);

    // console.log("mounted===this.userInfo", this.userInfo);
    console.log("mounted===this.parkId", this.parkId);
    this.weatherInit();
    //查询园区列表
    this.getParkList();
    this.getDeviceList();
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); //月份是从0开始计数的，所以要加1
    let day = currentDate.getDate().toString().padStart(2, "0");
    let hour = currentDate.getHours().toString().padStart(2, "0");
    let minute = currentDate.getMinutes().toString().padStart(2, "0");
    let formattedDate = `${year}-${month}-${day} ${hour}:${minute}`;

    // let formattedDate = `${year}-${month}-${day}`;
    this.nowTime = this.getNextDay(formattedDate);
    // this.nowTime = "2025-11-11";
    console.log("nowTime===", this.nowTime);
    this.map.options && this.map.destroy();
    this.map = {};
    this.newMap();
    //this.leftOneECharts = echarts.init(document.getElementById("leftMainOne"));
    //this.leftOneECharts.setOption(this.leftOneOption);
    //this.leftTwoECharts = echarts.init(document.getElementById("leftMainTwo"));
    //this.leftTwoECharts.setOption(this.leftTwoOption);
  },
  methods: {
    getParkList() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      // let params = {
      //   deptId: 141,
      // };

      this.$axios
        .get("/massif/list", {
          params: params,
        })
        .then((res) => {
          console.log("园区列表-error===", res);
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].massifPic != null) {
              res.data[i].massifPic = res.data[i].massifPic.split(",");
            }
          }
          this.parkList = res.data;
        })
        .catch((error) => {
          console.log("园区列表-error===", error);
        });
    },
    weatherInit() {
      console.log("data", this.data);
      let httpData = {
        location: "102.180929,38.514691",
      };

      this.$axios
        .get("/qweather/getWeather", {
          params: httpData,
        })
        .then((res) => {
          console.log("天气数据", res);
          this.weatherData = res.now;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getDeviceList() {
      // let params = {
      //   deptId: 141,
      // };
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      let http = "hothouseDevice/list";
      params.hothouseDeviceMid = this.parkId;
      // if (this.warmType == 0) {
      // 	params.hothouseDeviceMid = this.parkId;
      // 	http = "hothouseDevice/list";
      // 	console.log("日光温室hothouseDevice/list-params===", params);
      // } else if (this.warmType == 1) {
      // 	params.linkageDeviceMid = this.parkId;
      // 	http = "linkageDevice/list";
      // 	console.log("日光温室hothouseDevice/list-params===", params);
      // }
      this.$axios
        .get(http, {
          params: params,
        })
        .then((res) => {
          console.log("日光温室hothouseDevice/list-res===", res.data);
          if (this.warmType == 0) {
            console.log("日光温室hothouseDevice/list-res===", res.data);
          } else if (this.warmType == 1) {
            console.log("连栋温室linkageDevice/list-res===", res.data);
          }
          if (res.data.length != 0) {
            this.deviceList = res.data;

            let zainum=0;
            let lixiannum=0;
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].hothouseDeviceState == 2) {
                zainum++;
              } else if (res.data[i].hothouseDeviceState == 1){
                lixiannum++;
              }
            }
            this.leftOneOption.series[0].data[1].value=res.data.length;
            
            this.leftTwoOption.series[0].data[0].value=zainum;
            this.leftTwoOption.series[0].data[1].value=lixiannum;

            this.leftOneECharts = echarts.init(document.getElementById("leftMainOne"));
            this.leftOneECharts.setOption(this.leftOneOption);
            this.leftTwoECharts = echarts.init(document.getElementById("leftMainTwo"));
            this.leftTwoECharts.setOption(this.leftTwoOption);


            this.changeDeviceItem = res.data[0];
            this.initEcharts();
            // 实时数据
            if (res.data[0].hothouseDeviceState == 2) {
              this.getRealTimeDeviceDataReadingsArray(res.data[0]);
            }
          }

          this.getLive(
            this.warmType == 0
              ? this.deviceList[0].hothouseDeviceVid
              : this.deviceList[0].linkageId,
            this.deviceList[0].hothouseDevicePid
          );

          // if (res.data.length != 0) {
          // 	this.warmList = res.data;
          // 	let dataList = this.warmList[0].hothouseDeviceDataList;
          // 	if (this.warmType == 0) { //日光温室
          // 		// 调用新接口
          // 		if (res.data[0].hothouseDeviceState == 2) {
          // 			this.getRealTimeDeviceDataReadingsArray(res.data[0]);
          // 		}

          // 	} else if (this.warmType == 1) { //连栋温室
          // 		for (let i in dataList) {
          // 			//实时数据
          // 			if (dataList[i].hothouseDeviceDataType == "0036") {
          // 				this.DataList.ppm = parseFloat(
          // 					dataList[i].hothouseDeviceDataVal
          // 				).toFixed(1);
          // 			} else if (dataList[i].hothouseDeviceDataType == "0038") {
          // 				this.DataList.lux = parseFloat(
          // 					dataList[i].hothouseDeviceDataVal
          // 				).toFixed(1);
          // 			} else if (dataList[i].hothouseDeviceDataType == "0032") {
          // 				this.DataList.RH = parseFloat(
          // 					dataList[i].hothouseDeviceDataVal
          // 				).toFixed(1);
          // 			} else if (dataList[i].hothouseDeviceDataType == "0034") {
          // 				this.DataList.C = parseFloat(
          // 					dataList[i].hothouseDeviceDataVal
          // 				).toFixed(1);
          // 			}
          // 		}
          // 		if (res.data[0].linkageDeviceState == 2) {
          // 			this.getRealTimeDeviceDataReading(
          // 				this.warmList[0].linkageDeviceNumber,
          // 				this.warmList[0].linkageDeviceState
          // 			);
          // 		}

          // 	}

          // 	this.getLive(this.warmType == 0 ? this.warmList[0].hothouseDeviceVid : this.warmList[0]
          // 		.linkageId, this.warmList[0].hothouseDevicePid);

          // 	this.getMainOneEchatrs(
          // 		this.warmType == 0 ?
          // 		this.warmList[0].hothouseDeviceNumber :
          // 		this.warmList[0].linkageDeviceNumber
          // 	);
          // 	this.getMainTwoEchatrs(
          // 		this.warmType == 0 ?
          // 		this.warmList[0].hothouseDeviceNumber :
          // 		this.warmList[0].linkageDeviceNumber
          // 	);
          // 	this.getMainThreeEchatrs(
          // 		this.warmType == 0 ?
          // 		this.warmList[0].hothouseDeviceNumber :
          // 		this.warmList[0].linkageDeviceNumber
          // 	);

          // } else {
          // 	this.initMainOneEchatrs();
          // 	this.initMainTwoEchatrs();
          // 	this.initMainThreeEchatrs();
          // }
        })
        .catch((error) => {
          if (this.warmType == 0) {
            console.log("日光温室hothouseDevice/list-error===", error);
          } else if (this.warmType == 1) {
            console.log("连栋温室linkageDevice/list-error===", error);
          }
        });
    },

    getLive(monitorVideoVid, monitorVideoPid) {
      this.liveList = [];
      let params = {
        monitorVideoStype: 1,
        monitorVideoId: monitorVideoVid, //this.warmList[0].hothouseDeviceId, //8,
        protocol: 2,
      };

      console.log("123123==========", params);
      this.$axios
        .get("/cameraApi/GetAddress", {
          params: params,
        })
        .then((res) => {
          console.log("直播地址-res===", res);
          console.log("直播地址-monitorVideoPid===", monitorVideoPid);
          if (res.data.length != 0) {
            let data = [];
            data.push(res.data[monitorVideoPid]);
            res.data = data;
            for (let i in res.data) {
              if (res.data[i].msg == "操作成功") {
                this.liveList.push(res.data[i]);
                console.log("this.liveList", this.liveList);
                setTimeout(function () {
                  // 创建video.js实例
                  let player = videojs(
                    "myVideo" + res.data[i].channelNo,
                    {
                      controls: true, // 是否显示控制条
                      autoplay: true, // 是否自动播放
                      preload: "auto", // 预加载方式
                      fluid: true, // 是否使用响应式布局
                      muted: true,
                      language: "zh-CN",
                      sources: [
                        {
                          src: res.data[i].data.url, //"https://open.ys7.com/v3/openlive/AE1843072_1_1.m3u8?expire=1703124567&id=657524963728691201&t=0d95033fce9b749655b9ce478e0ad7d053d9b8bae3d82322f87ec090dac48f77&ev=100",
                          type: "application/x-mpegURL",
                        },
                      ],
                    },
                    function () {
                      // console.log('--------------播放器加载完成后的回调函数myVideo', i)
                      this.on("play", function () {
                        console.log("play播放===", res.data[i].data.url);
                      });
                      this.on("dispose", function () {
                        console.log("dispose销毁===", i);
                      });
                      this.on("ended", function () {
                        console.log("end结束===", i);
                      });
                    }
                  );
                  console.log("play播放===player", player);
                  player.play();
                }, 1000);
              } else if (res.data[i].msg == "设备不在线") {
                //this.liveList.push(res.data[i]);
              }
            }
          }
        })
        .catch((error) => {
          console.log("直播地址-error===", error);
        });
    },

    getRealTimeDeviceDataReadingsArray(ress) {
      // console.log('-------------------------调用新接口')
      // console.log('getRealTimeDeviceDataReadingsArray-ress', ress)
      let httpData = {
        deviceId: ress.hothouseDeviceNumber,
        queueType: 0,
        queueld: "",
      };
      console.log("getRealTimeDeviceDataReadingsArray-httpData", httpData);
      this.$axios
        .post("/DeviceMqttPushApi/RealTimeDeviceDataReadingsArray", httpData)
        .then((res) => {
          console.log("getRealTimeDeviceDataReadingsArray-res", res);
          if (res.msg == "操作成功") {
            let newDataList = [];
            newDataList = newDataList.concat(
              res.data.sequence1,
              res.data.sequence2,
              res.data.sequence3
            );
            console.log(
              "getRealTimeDeviceDataReadingsArray-res操作成功",
              newDataList
            );
            this.newResData(newDataList);
          }
          if (res.code == 500) {
            this.$axios
              .post("/DeviceMqttPushApi/clearQueue", {
                deviceId: ress.hothouseDeviceNumber,
              })
              .then((res) => {
                console.log("clearQueue-清空后重查---", res);
                this.getRealTimeDeviceDataReadingsArray(ress);
              })
              .catch((error) => {
                console.log("clearQueue-error---", error);
              });
          }
          this.loadingType = false;
        })
        .catch((error) => {
          console.log("getRealTimeDeviceDataReadingsArray-error", error);
          this.loadingType = false;
        });
    },
    newResData(res) {
      console.log("-------------------------日光温室处理进度");
      for (let i in res) {
        if (res[i].pointVue == "0008") {
          this.changeDeviceItemData.PPM = parseFloat(res[i].result).toFixed(1);
        }
        if (res[i].pointVue == "000A") {
          this.changeDeviceItemData.LUX = parseFloat(res[i].result).toFixed(1);
        }
        if (res[i].pointVue == "0004") {
          this.changeDeviceItemData.RH = parseFloat(res[i].result).toFixed(1);
        }
        if (res[i].pointVue == "0006") {
          this.changeDeviceItemData.C = parseFloat(res[i].result).toFixed(1);
        }
        if (res[i].pointVue === "0045") {
          //卷帘机1进度
          console.log("双卷帘 卷帘机1进度---res[i]", res[i]);
          this.changeDeviceItemDataStatus[0].num = parseInt(res[i].result);
        }
        if (res[i].pointVue === "0046") {
          //卷帘机2进度
          console.log("双卷帘 卷帘机2进度---res[i]", res[i]);
          this.changeDeviceItemDataStatus[1].num = parseInt(res[i].result);
        }
        if (res[i].pointVue === "0047") {
          //上风口
          console.log("上风口进度---res[i]", res[i]);
          this.changeDeviceItemDataStatus[2].num = parseInt(res[i].result);
        }
        if (res[i].pointVue === "0048") {
          //下风口
          console.log("下风口进度---res[i]", res[i]);
          this.changeDeviceItemDataStatus[3].num = parseInt(res[i].result);
        }
        if (res[i].pointVue === "0053") {
          //喷淋运行时间设置
          console.log("喷淋运行时间设置---res[i]", res[i]);
          this.changeDeviceItemDataStatus[4].num = res[i].result;
        }
        if (res[i].pointVue === "0054") {
          //补光运行时间设置
          console.log("补光运行时间设置---res[i]", res[i]);
          this.changeDeviceItemDataStatus[5].num = res[i].result;
        }

        // if (res[i].hothouseDeviceDataType === "0032") {
        // 	// let num = res[i].hothouseDeviceDataVal;
        // 	// let number = this.decimalToBinary(num);
        // 	// let state = this.padTo15Digits(number);
        // 	// let switchVal = state.split("").map(Number);
        // 	let switchVal = res[i].result;

        // 	this.deviceStatus[0].type = switchVal[16 - 9] == 1 ? true : false;
        // 	this.deviceStatus[0].type1 = switchVal[16 - 10] == 1 ? true : false;
        // 	this.deviceStatus[1].type = switchVal[16 - 11] == 1 ? true : false;
        // 	this.deviceStatus[1].type1 = switchVal[16 - 12] == 1 ? true : false;
        // 	this.deviceStatus[2].type = switchVal[16 - 13] == 1 ? true : false;
        // 	this.deviceStatus[2].type1 = switchVal[16 - 14] == 1 ? true : false;
        // 	this.deviceStatus[3].type = switchVal[16 - 15] == 1 ? true : false;
        // 	this.deviceStatus[3].type1 = switchVal[16 - 16] == 1 ? true : false;
        // 	this.deviceStatus[4].type = switchVal[16 - 1] == 1 ? true : false;
        // 	this.deviceStatus[5].type = switchVal[16 - 2] == 1 ? true : false;
        // }
      }
      console.log(
        "this.changeDeviceItemDataStatus-------",
        this.changeDeviceItemDataStatus
      );
      console.log("-------------------------日光温室处理进度END");
    },
    changeDevice(item) {
      console.log("changeDevice-item", item);

      this.getLive(
        this.warmType == 0 ? item.hothouseDeviceVid : item.linkageId,
        item.hothouseDevicePid
      );
      this.changeDeviceItem = item;
      this.changeDeviceItemData = {
        //切换设备实时数据（当前的）
        C: "-",
        RH: "-",
        LUX: "-",
        PPM: "-",
      };
      this.changeDeviceItemDataStatus = [
        {
          //切换设备实时数据（当前的）
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
          type1: false,
        },
        {
          num: "-",
          type: false,
        },
        {
          num: "-",
          type: false,
        },
      ];
      // 实时数据
      if (this.changeDeviceItem.hothouseDeviceState == 2) {
        this.getRealTimeDeviceDataReadingsArray(this.changeDeviceItem);
      }
      this.initEcharts();
    },
    initEcharts() {
      console.log("-------------------------initEcharts");
      if (this.changeDeviceItem.hothouseDeviceState != 2) {
        // 判断是否echarts是否初始化过
        // if (!this.rightOneECharts.id) {
        this.rightOneECharts = echarts.init(
          document.getElementById("rightMainOne")
        );
        // }
        this.rightOneOption.series[0].data = [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ];
        this.rightOneOption.series[1].data = [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ];
        this.rightOneECharts.setOption(this.rightOneOption);

        // if (!this.rightTwoECharts.id) {
        this.rightTwoECharts = echarts.init(
          document.getElementById("rightMainTwo")
        );
        // }
        this.rightTwoOption.series[0].data = [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ];
        this.rightTwoECharts.setOption(this.rightTwoOption);

        // if (!this.rightThreeECharts.id) {
        this.rightThreeECharts = echarts.init(
          document.getElementById("rightMainThree")
        );
        // }
        this.rightThreeOption.series[0].data = [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ];
        this.rightThreeECharts.setOption(this.rightThreeOption);
      } else {
       
      }
       //在线
        this.getRightOneECharts(); //空气温湿度
        this.getRightTwoECharts(); //二氧化碳
        this.getRightThreeECharts(); //光照度
    },
    getRightOneECharts() {

      if(this.powerInfo){
        var region=this.powerInfo.powerWarmRegion1.split(",");
        var regionName=this.powerInfo.powerWarmRegion1Name.split(",");
        var regionUnit=this.powerInfo.powerWarmRegion1Unit.split(",");
        console.log("region",region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo?region[0]:"0004", //0004空气湿度 0006温度
        deviceAddr: this.changeDeviceItem.hothouseDeviceNumber, //设备ID
      };
      this.$axios
        .get("/hothouseDeviceData", {
          params: httpData,
        })
        .then((data) => {
          console.log("getMainOneEchatrs湿度-echart---res1", data);
          let sdArr = [];
          let xData = [];
          for (let i in data.data) {
            sdArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            xData.push(xDataHour);
            // xData.push(data.data[i].x);
          }
          let httpData2 = {
            seachType: 0,
            time: this.nowTime,
            dataType: this.powerInfo?region[1]:"0006", //0006空气温度
            deviceAddr: this.changeDeviceItem.hothouseDeviceNumber, //设备ID
          };
          this.$axios
            .get("/hothouseDeviceData", {
              params: httpData2,
            })
            .then((res) => {
              console.log("getMainOneEchatrs温度-echart---res2", res);
              let wdArr = [];
              for (let i in res.data) {
                wdArr.push(parseFloat(res.data[i].y).toFixed(2));
              }
              // 判断是否echarts是否初始化过
              // if (!this.rightOneECharts.id) {
              this.rightOneECharts = echarts.init(
                document.getElementById("rightMainOne")
              );
              // }
              this.rightOneOption.xAxis.data = xData;
              this.rightOneOption.series[0].data = wdArr;
              this.rightOneOption.series[1].data = sdArr;
              this.rightOneOption.legend.data[0].name=regionName[0];
              this.rightOneOption.legend.data[1].name=regionName[1];
              this.rightOneOption.yAxis[0].name=regionUnit[0];
              this.rightOneOption.yAxis[1].name=regionUnit[1];
              this.rightOneECharts.setOption(this.rightOneOption);
            })
            .catch((error2) => {
              console.log("getMainOneEchatrs温度-echart---error2===2", error2);
            });
        })
        .catch((error) => {
          console.log("getMainOneEchatrs湿度-echart---error===1", error);
        });
    },
    getRightTwoECharts() {
      if(this.powerInfo){
        var region=this.powerInfo.powerWarmRegion2.split(",");
        var regionUnit=this.powerInfo.powerWarmRegion2Unit.split(",");
        console.log("region",region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo?region[0]:"0008", //0008二氧化碳
        deviceAddr: this.changeDeviceItem.hothouseDeviceNumber, //设备ID
      };
      this.$axios
        .get("/hothouseDeviceData", {
          params: httpData,
        })
        .then((data) => {
          console.log("getMainThreeEchatrs二氧化碳-echart---data", data);
          let yArr = [];
          let xData = [];
          for (let i in data.data) {
            yArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            xData.push(xDataHour);
            // xData.push(data.data[i].x);
          }
          // 判断是否echarts是否初始化过
          // if (!this.rightTwoECharts.id) {
          this.rightTwoECharts = echarts.init(
            document.getElementById("rightMainTwo")
          );
          // }
          this.rightTwoOption.xAxis.data = xData;
          this.rightTwoOption.series[0].data = yArr;
          this.rightTwoOption.yAxis.name=regionUnit[0];
          this.rightTwoECharts.setOption(this.rightTwoOption);
        })
        .catch((error) => {
          console.log("getMainThreeEchatrs二氧化碳-echart---error", error);
        });
    },
    getRightThreeECharts() {
       if(this.powerInfo){
        var region=this.powerInfo.powerWarmRegion3.split(",");
         var regionUnit=this.powerInfo.powerWarmRegion3Unit.split(",");
        console.log("region",region);
      }
      let httpData = {
        seachType: 0,
        time: this.nowTime,
        dataType: this.powerInfo?region[0]:"000A", //000A光照强度
        deviceAddr: this.changeDeviceItem.hothouseDeviceNumber, //设备ID
      };
      this.$axios
        .get("/hothouseDeviceData", {
          params: httpData,
        })
        .then((data) => {
          console.log("getMainTwoEchatrs光照强度-echart---data", data);
          let yArr = [];
          let xData = [];
          for (let i in data.data) {
            yArr.push(data.data[i].y);
            let xDataHour = data.data[i].x.substring(
              data.data[i].x.length - 5,
              data.data[i].x.length
            );
            xData.push(xDataHour);
          }
          // 判断是否echarts是否初始化过
          // if (!this.rightThreeECharts.id) {
          this.rightThreeECharts = echarts.init(
            document.getElementById("rightMainThree")
          );
          // }
          this.rightThreeOption.xAxis.data = xData;
          this.rightThreeOption.series[0].data = yArr;
          this.rightThreeOption.yAxis.name=regionUnit[0];
          this.rightThreeECharts.setOption(this.rightThreeOption);
        })
        .catch((error) => {
          console.log("getMainTwoEchatrs光照强度-echart---error", error);
        });
    },
    getNextDay(dateString) {
      // console.log('--getNextDay--', dateString)
      // 创建一个日期对象
      var date = new Date(dateString);
      // 获取当前日期的毫秒数
      var milliseconds = date.getTime();
      // 将毫秒数增加一天的毫秒数
      milliseconds += 24 * 60 * 60 * 1000;
      // 创建一个新的日期对象，使用增加后的毫秒数
      var nextDay = new Date(milliseconds);
      // 获取新日期的年、月、日
      var year = nextDay.getFullYear();
      var month = nextDay.getMonth() + 1; // 月份从0开始，需要加1
      var day = nextDay.getDate() - 1;
      var hour = nextDay.getHours();
      var minute = nextDay.getMinutes();
      var formattedDate =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        day.toString().padStart(2, "0") +
        " " +
        hour.toString().padStart(2, "0") +
        ":" +
        minute.toString().padStart(2, "0");
      // 格式化日期为YYYY-MM-DD hh:mm的形式
      // console.log('日历----', formattedDate)
      return formattedDate;
    },
    newMap() {
      // console.log('newMap', this.mapRadio);
      let lngLat = this.mapLat != "" ? this.mapLat.split(",") : [];

      if (lngLat.length > 0) {
        lngLat.push(lngLat[0]);
        lngLat.push(lngLat[1]);
      }
      let scripts = [];
      if (this.mapRadio == "标准") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6",
          "https://cache.amap.com/lbs/static/es5.min.js",
        ];
      } else if (this.mapRadio == "卫星") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=Map3D",
        ];
      } else if (this.mapRadio == "3D") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ControlBar",
        ];
      } else if (this.mapRadio == "室内") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ToolBar",
          "https://webapi.amap.com/demos/js/liteToolbar.js",
        ];
      }

      scripts.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
          // 外部 JS 文件加载成功后的回调函数
          // console.log('气象newMap加载成功');

          // 这是中心点的经纬度
          // 业务中应该是获取当前位置
          if (this.mapRadio == "标准") {
            this.map = new AMap.Map("container", {
              resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "amap://styles/fresh",
              zoom: this.mapLat != "" ? 6 : 13, //初始化地图层级
              center:
                this.mapLat != ""
                  ? lngLat
                  : [this.devItem.devicelng, this.devItem.devicelat], // 初始化地图中心点
            });
          } else if (this.mapRadio == "卫星") {
            this.map = new AMap.Map("container", {
              center:
                this.mapLat != ""
                  ? lngLat
                  : [this.devItem.devicelng, this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 13, //初始化地图层级
              mapStyle: "amap://styles/fresh",
              features: ["road", "bg"],
            });

            let satellite = new AMap.TileLayer.Satellite({
              map: this.map,
            });
          } else if (this.mapRadio == "3D") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              rotateEnable: true,
              pitchEnable: true,
              zoom: this.mapLat != "" ? 14 : 17, //初始化地图层级
              pitch: 80,
              rotation: -15,
              viewMode: "3D", //开启3D视图,默认为关闭
              buildingAnimation: true, //楼块出现是否带动画

              expandZoomRange: true,
              zooms: [3, 20],
              center:
                this.mapLat != ""
                  ? lngLat
                  : [this.devItem.devicelng, this.devItem.devicelat], // 初始化地图中心点
            });

            this.map.addControl(
              new AMap.ControlBar({
                showZoomBar: false,
                showControlButton: true,
                position: {
                  right: "10px",
                  top: "10px",
                },
              })
            );
          } else if (this.mapRadio == "室内") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              center:
                this.mapLat != ""
                  ? lngLat
                  : [this.devItem.devicelng, this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 18, //初始化地图层级
              pitch: 50,
              viewMode: "3D",
            });

            this.map.on("indoor_create", function () {
              this.map.indoorMap.showIndoorMap("B000A856LJ", 5);
            });
          }

          if (lngLat.length > 0) {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = lngLat[0];
            let lngLats = lngLat[1];
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          } else {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = this.devItem.devicelng;
            let lngLats = this.devItem.devicelat;
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          }
          this.loading = false;
        };
        script.onerror = (err) => {
          // 外部 JS 文件加载失败后的回调函数
          // console.log('气象newMap加载失败', err);
          this.loading = false;
        };
        document.head.appendChild(script);
      });
    },
  },
};
</script>

<style></style>

<style scoped>
/* 隐藏滚动条 */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.header-tab-bg {
  width: 100%;
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1728613073976.png");
  background-size: 100% 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-tab-text {
  margin-left: 30px;
}

.header-tab-text-right {
  margin-right: 30px;
}

.header-tab-text-span {
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #90deff);
  -webkit-background-clip: text;
  color: transparent;
}

.title1-img {
  width: 100%;
  height: 40px;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704183078849.png");
  background-size: 100% 100%;
}

.titles {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
  position: relative;
  top: -10px;
  font-size: 20px;
  font-weight: 600;
}
</style>
